
import { supabase } from "@/integrations/supabase/client";
import { BaseApiClient } from "../../baseApiClient";
import { logger } from "@/lib/logger";
import { BusinessSubscriptionDetails } from "../types";
import { subscriptionMapper } from "../../subscription/mappers";

/**
 * Fetches subscription details for a business
 */
export async function fetchSubscriptionDetails(
  businessId: string
): Promise<BusinessSubscriptionDetails | null> {
  return BaseApiClient.request<BusinessSubscriptionDetails | null>(
    `business:subscription:${businessId}`,
    async () => {
      try {
        const { data, error } = await supabase
          .from('business')
          .select('subscription_status, plan_name, current_period_end')
          .eq('id', businessId)
          .maybeSingle();
          
        if (error) {
          throw new Error(`Failed to fetch subscription details: ${error.message}`);
        }
        
        if (!data) return null;
        
        return {
          status: data.subscription_status || 'inactive',
          planName: data.plan_name || 'Basic',
          endDate: data.current_period_end || null,
        };
      } catch (error) {
        logger.error({
          message: "Error fetching subscription details",
          error: error instanceof Error ? error : new Error(String(error)),
          context: { businessId }
        });
        throw error;
      }
    }
  );
}
